<template>
    <div id="detalles">
        <button @click="closeDet" class="cruz"><img src="@/assets/img/cruz.svg" alt=""></button>
        <h2 id="titDet"></h2>
        <h4 id="bajDet"></h4>
        <a id="but1" class="but" target="_blamk"></a>
        <p id="texDet" class="textD"></p>
        <div id="divImag1" class="imagD">
            <img id="imag1Det" alt="">
        </div>
        <!-- <p id="tex2Det" class="text"></p> -->
        <a id="but2" class="but" target="_blank"></a>
        <div id="divImag2" class="imagD">
            <img id="imag2Det" src="" alt="">
        </div>
        <div class="fin"></div>
    </div>
</template>
<script>

import ScrollReveal from 'scrollreveal'
export default {
    props: {
        detalles: {
            type: Array,
            default: () => []
        },
        abre: {
            type: Boolean,
            default: false
        },
        esteId: {
            // type: String,
            default: null,
        },
        mobile: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            detalle: this.detalles,
            work: this.esteWork(this.esteId),
        }
    },
    created() {
        // this.initScrollReveal();
    },

    methods: {
        esteWork(id){
            // console.log('ESTEID', id);
            
            setTimeout(() => {
                const titDet = document.getElementById('titDet');
                const bajDet = document.getElementById('bajDet');
                const texDet = document.getElementById('texDet');
                const divImag1 = document.getElementById('divImag1')
                const divImag2 = document.getElementById('divImag2')
                // const divImag2 = document.getElementById('divImag2')
                // const imag1Det = document.getElementById('imag1Det');
                const but1 = document.getElementById('but1');
                // const tex2Det = document.getElementById('tex2Det');
                // const imag2Det = document.getElementById('imag2Det');
                const but2 = document.getElementById('but2');

                this.detalles.forEach((w) => {
                    // console.log('FOR', w);

                    if(id == w.id){
                        // console.log('IGUAL');
                        
                        var arrImag = w.imagenes.split(',');
                        titDet.innerHTML = w.titulo;
                        bajDet.innerHTML = w.bajada;
                        texDet.innerHTML = w.texto;
                        arrImag.forEach((im) => {
                            // console.log('VID', im);
                            if(im.includes('.mp4')){
                                divImag1.innerHTML = `<video autoplay loop muted width='80%'>
                                <source src="https://www.nicolasrivera.com.ar/media/${im}" type="video/mp4">
                                Your browser does not support the video tag.</video>`;
                            } else {
                                // console.log('ELSE', id, w.id);
                                
                                divImag1.classList.add('no');
                                let imag = document.createElement('img');
                                imag.setAttribute("class", "imagDet");
                                if(id.toString().includes('il')){
                                    imag.setAttribute('src', 'https://www.nicolasrivera.com.ar/img/illus/' + im.trim());
                                }else{
                                    imag.setAttribute('src', 'https://www.nicolasrivera.com.ar/img/infos/' + im.trim());
                                }
                                if(this.mobile){
                                    imag.style.width = '100%';
                                } else {
                                    imag.style.width = '80%';
                                }
                                imag.style.margin = '15px auto 75px';
                                divImag2.appendChild(imag);
                            }
                        })
                        // but1.innerHTML = w.boton;
                        // but1.href = w.link;
                        // imag2Det.src = 'https://www.nicolasrivera.com.ar/img/infos/' + arrImag[1].trim();
                        // console.log('W', w.imagenes);
                        if(w.boton != 'a' && w.link != 'b'){
                            but1.innerHTML = w.boton;
                            but1.href = w.link;
                        } else {
                            but1.classList.add('no')
                        }
                        if(w.boton2 != 'a' && w.link2 != 'b'){
                            but2.innerHTML = w.boton2;
                            but2.href = w.link2;
                        } else {
                            but2.classList.add('no')
                        }
                    }
                })
            }, 500);
        },
        closeDet(){
            this.$emit('cerrarDetalles', false)
        },
        initScrollReveal() {
            // console.log('esteId', this.work);
            
        // // Aplica la animación a los elementos con la clase 'reveal-animation'
        const revealElements = document.querySelectorAll('.stepLi');
            // console.log(revealElements);
            
            const scrollRev = ScrollReveal({
                distance: "50px",
                duration: 1000,
                delay: 150,
                reset: false
            })

            revealElements.forEach(element => {                
                scrollRev.reveal(element);
            });
        },
        openModal(id){
            // const modal = document.getElementById('imageModal');
            // modal.style.display = "block";
            setTimeout(() => {
                const divImg = document.getElementById('titDetalle');
    
                this.detalles.forEach((d) => {
                    if(d.id == id){
                        // console.log('ESTE', d.texto);
                        divImg.innerHTML = `Holaaaaaa`
                    }
                   
                })
            }, 1000);
        }
    }
}
</script>
<style lang='scss' scoped>
    #detalles{
        background: var(--black);
        padding: 20px 0px 80px;
        border-top: 13px solid var(--black);
        display: flex;
        height: 100vh;
        flex-direction: column;
        left: 0;
        position: sticky;
        text-align: center;
        top: 60px;
        visibility: visible;
        width: 100%;
        z-index: 30000;
        overflow: scroll;

        .cruz{
            border-radius: 30px;
            height: 40px;
            left: 92%;
            position: sticky;
            text-align: left;
            top: 10px;
            width: 40px;
            padding: 13px;
            background: var(--black);
            border: 1px solid var(--white);
            cursor: pointer;
            transition: all .3s ease;
            text-align: center;
            &:hover{
                border: 1px solid aqua;
                background: aqua;
                color: var(--white);
            }
            img{
                width: 30px;
                height: 30px;
                margin: -9px;
            }
            // p{
            //     font-family: var(--roboto);
            //     font-weight: 400;
            //     font-size: 1.5rem;
            //     line-height: 0;
            //     margin-top: -1px;
            //     margin-left: -6px;
            // }
        }

        // h1{
        //     color: var(--white);
        //     font-family: var(--roboto);
        //     font-size: 1rem;
        //     font-weight: 300;
        //     padding-top: 70px;
        //     // letter-spacing: 150px;
        //     // transform: translateX(6%);
        //     @media screen and (max-width: 600px){
        //         font-size: 3rem;
        //     }
        // }
        // h2{
        //     color: var(--white);
        //     font-family: var(--roboto);
        //     font-size: 2rem;
        //     font-weight: 100;
        //     width: 100%;
        // }
        #titDet, #bajDet{
            line-height: 1;
            margin: 0px auto;
            text-align: center;
            font-family: var(--roboto);
            color: aqua;
            font-size: 2rem;
            font-weight: 400;
            // padding-bottom: 50px;
            width: fit-content;
        }
        #bajDet{
            line-height: 2;
            position: relative;
            letter-spacing: .2px;
            font-weight: 200;
            border-bottom: 1px solid aqua;
            margin: 0 auto 50px;
            font-size: 1.2rem;
            padding-bottom: 30px;

            &::before{
                content: "";
                width: 8px;
                height: 20px;
                background: var(--black);
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
            }
            &::after{
                content: "N";
                color: aqua;
                position: absolute;
                font-family: var(--roboto);
                font-weight: 300;
                font-size: 15px;
                bottom: -15px;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        #divImag1, #divImag2, #texDet, #tex2Det{
            &.no{
                display: none;
            }
            a.linkD{
                color: var(--white) !important;
                font-weight: 600 !important;
            }
        }
        .textD{
            font-family: var(--roboto);
            color: var(--white);
            font-size: 1.1rem;
            font-weight: 200;
            letter-spacing: .2px;
            width: 50%;
            margin: 30px auto;
            line-height: 1.5;
            text-align: left;
        }
        .imagD{
            width: 60%;
            margin: 30px auto;
            video{
                width: 80%;
                margin: 0 auto 75px;
            }
            .imagDet{
                width: 80%;
                margin: 15px auto 75px;
            }
        }
        .but{
            font-family: var(--roboto);
            background: var(--black);
            padding: 10px 20px;
            font-weight: 400;
            color: var(--white);
            text-decoration: none;
            border: 1px solid var(--white);
            border-radius: 50px;
            width: fit-content;
            margin: 20px auto;
            transition: all .3s ease;
            &:hover{
                color: var(--black);
                background: aqua;
                // border: 1px solid var(--black);
            }
            &.no{
                display: none;
            }
        }
        .fin{
            border-top: 1px solid aqua;
            // padding-bottom: 50px;
            margin: 0 auto 40px;
            width: 40%;
            position: relative;
            &::before{
                content: "";
                width: 5px;
                height: 20px;
                background: var(--black);
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
            }
            &::after{
                content: "R";
                color: aqua;
                position: absolute;
                font-family: var(--roboto);
                font-weight: 300;
                font-size: 15px;
                top: -10px;
                left: 50%;
                transform: translateX(-40%);
            }
        
        }
    }
    @media screen and (max-width: 950px){
        #detalles{
            #titDet{
                font-size: 1.6rem;
                line-height: 1.3;
                width: 90%;
                margin-top: 20px;
                padding-bottom: 0px;
            }
            .textD{
                width: 75%;
            }
            .imagD{
                width: 90%;
                .imagDet{
                    width: 100%;
                }
            }
            .cruz{
                height: 35px;
                left: 87%;
                top: 0px;
                width: 35px;
                padding: 10px;
                img{
                    width: 25px;
                    height: 25px;
                    margin: -7px;
                }
            }
        }
    }
    @media screen and (max-width: 500px){
        #detalles{
            .imagD{
                width: 100%;
            }
        }
    }
</style>